import script from "./sf-assistant-checks-container.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-assistant-checks-container.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__